"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This allows the user to accept a waiting list
// entry as complete where that entry does not require online payment.
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "This will move the entry to the Completed Entries list.");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "This is an online entry, therefore the paddler will be automatically notified that they have a place.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "This is a postal entry, therefore please note that the paddler will NOT be automatically notified.");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", {
  className: "text-danger lead"
}, "This postal entry has not been marked as paid. Please make sure that you have correctly set the RTC codes to show this.");
class AcceptEntryModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onConfirmAcceptEntry", () => {
      this.props.onMoveWaitToComp(this.props.entry.id);
    });
  }
  render() {
    const entry = this.props.entry;
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.props.onToggleAcceptEntry
    }, "Cancel Request"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onConfirmAcceptEntry,
      type: "primary"
    }, "Confirm Request"));
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Accept postal entry",
      buttons: modalButtons,
      onClose: this.props.onToggleAcceptEntry
    }, _ref, entry.isOnlineEntry ? _ref2 : /*#__PURE__*/_react.default.createElement("div", null, _ref3, entry.hasPaid || !entry.competitionDivision.isFreeToEnter ? null : _ref4));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(AcceptEntryModal, "partialQueries", {
  Entry: {
    id: true,
    hasPaid: true,
    isOnlineEntry: true,
    competitionDivision: {
      isFreeToEnter: true
    }
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(AcceptEntryModal, undefined, (client, props) => ({
  onMoveWaitToComp(entryID) {
    return client.update('Entry.moveWaitToComp', {
      entryID
    });
  }
}));